import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { MessageModule } from 'primeng/message';
import { HttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { catchError, of } from 'rxjs';
import { environment } from '../../../../environments/environments';

@Component({
  selector: 'app-confirm-email',
  imports: [
    ButtonModule, 
    CommonModule, 
    CardModule, 
    MessageModule, 
    ToastModule,
    ProgressSpinnerModule
  ],
  templateUrl: './confirm-email.component.html',
  styleUrl: './confirm-email.component.scss',
  providers: [MessageService]
})
export class ConfirmEmailComponent implements OnInit {
  private router = inject(Router);
  private http = inject(HttpClient);
  private messageService = inject(MessageService);
  
  constructor(private route: ActivatedRoute) { }
  
  userId: string | null = null;
  isResending = false;
  
  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.userId = params.get('user_id');
    });
  }

  resendEmail() {
    if (!this.userId) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'User ID not found',
        life: 5000
      });
      return;
    }

    this.isResending = true;
    const apiUrl = environment.apiUrl + `api/auth/resend-confirmation/${this.userId}`;

    this.http.post(apiUrl, {}).pipe(
      catchError(error => {
        console.error('Resend error:', error);
        return of({ 
          error: error.error?.error || 'Failed to resend confirmation email',
          status: error.status 
        });
      })
    ).subscribe({
      next: (response: any) => {
        this.isResending = false;
        
        if (response.error) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: response.error,
            life: 5000
          });
        } else if (response.message === "Email already confirmed") {
          this.messageService.add({
            severity: 'info',
            summary: 'Already Confirmed',
            detail: 'Your email is already confirmed. You can proceed to login.',
            life: 5000
          });
        } else {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Confirmation email has been resent successfully. Please check your inbox.',
            life: 7000
          });
        }
      },
      error: (error) => {
        this.isResending = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Network Error',
          detail: 'Unable to resend email. Please try again later.',
          life: 5000
        });
      }
    });
  }

  goToDashboard() {
    this.router.navigate(['/']);
  }

  goToLogin() {
    this.router.navigate(['/auth/login']);
  }
}